import { Fragment, useState } from "react";
import { Dialog, Menu, Popover, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import cx from "classnames";
import {selectTheme} from "../../../data/booking/actions/map";

const sortOptions = [
    { id: "Date", name: "Par date", href: "#" },
    { id: "alpha", name: "Par ordre alphabetique", href: "#" },
    { id: "status", name: "Par état", href: "#" },
];

export default function TripsFilter({selectedFilters, setSelectedFilters, data}) {
    const [open, setOpen] = useState(false);

    function handleFilterChange(selectedFilter) {
        if (selectedFilters.some(filter => filter == selectedFilter)) {
            setSelectedFilters(selectedFilters.filter((filter) => filter !== selectedFilter));
        } else {
            setSelectedFilters(selectedFilters.concat(selectedFilter));
        }
    }

    return (
        <div className="relative bg-white">
            {/* Mobile filter dialog */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-40 flex">
                        <Transition.Child
                            as={Fragment}
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
                                <div className="flex items-center justify-between px-4">
                                    <h2 className="text-lg font-medium text-gray-900"></h2>
                                    <button
                                        type="button"
                                        className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="sr-only">Fermer le menu</span>
                                        <XMarkIcon
                                            className="h-6 w-6"
                                            aria-hidden="true"
                                        />
                                    </button>
                                </div>

                                <form className="mt-4">
                                    <div className="border-t border-gray-200 px-4 py-6">
                                        <div className="space-y-6">
                                            {data.map((option, optionIdx) => (
                                                <div
                                                    key={option.id}
                                                    className="flex items-center"
                                                >
                                                    <input
                                                        id={`filter-mobile-themes-${optionIdx}`}
                                                        name={`themes[]`}
                                                        type="checkbox"
                                                        className="h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
                                                        defaultChecked={
                                                            // Does options.value exist in selectedThemes?
                                                            selectedFilters.some(filter => filter == option.id)
                                                        }
                                                        onChange={() =>
                                                            handleFilterChange(
                                                                option.id
                                                            )
                                                        }
                                                    />
                                                    <label
                                                        htmlFor={`filter-mobile-themes-${optionIdx}`}
                                                        className="ml-3 text-sm text-gray-500"
                                                    >
                                                        {option.title}
                                                    </label>


                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </form>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>

            {/* Filters */}
            <section aria-labelledby="filter-heading">
                <h2 id="filter-heading" className="sr-only">
                    Filtrer
                </h2>

                <div>
                    <div className="mx-auto flex max-w-7xl items-center justify-between">
                        <button
                            type="button"
                            className="inline-block text-sm font-medium text-gray-700 hover:text-gray-900 lg:hidden"
                            onClick={() => setOpen(true)}
                        >
                            Filtrer
                        </button>

                        <div className="hidden lg:block">
                            <div className="flow-root">
                                <Popover.Group className="-mx-4 flex items-center divide-x divide-gray-200">
                                    <Popover className="relative inline-block px-4 text-left">
                                        <Popover.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                            <span>Filtrer</span>
                                            <span className="ml-1.5 rounded bg-gray-200 py-0.5 px-1.5 text-xs font-semibold tabular-nums text-gray-700">
                                                {selectedFilters.length}
                                            </span>
                                            <ChevronDownIcon
                                                className="-mr-1 ml-1 h-5 w-5 shrink-0 text-gray-400 group-hover:text-gray-500"
                                                aria-hidden="true"
                                            />
                                        </Popover.Button>

                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Popover.Panel className="absolute left-0 z-30 mt-2 origin-top-right rounded-md bg-white p-4 shadow-2xl ring-1 ring-orange-300 ring-opacity-5 focus:outline-none">
                                                <form className="space-y-4">
                                                    {data.map(
                                                        (option, optionIdx) => (
                                                            <div
                                                                key={option.id}
                                                                className="flex items-center"
                                                            >
                                                                <input
                                                                    id={`filter-themes-${optionIdx}`}
                                                                    name={`themes[]`}
                                                                    type="checkbox"
                                                                    className="h-4 w-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"
                                                                    defaultChecked={
                                                                        // Does options.value exist in selectedThemes?
                                                                        selectedFilters.some(filter => filter == option.id)
                                                                    }
                                                                    onChange={() =>
                                                                        handleFilterChange(
                                                                            option.id
                                                                        )
                                                                    }
                                                                />
                                                                <label
                                                                    htmlFor={`filter-themes-${optionIdx}`}
                                                                    className="ml-3 whitespace-nowrap pr-6 text-sm font-medium text-gray-900"
                                                                >
                                                                    {option.title}
                                                                </label>
                                                            </div>
                                                        )
                                                    )}
                                                </form>
                                            </Popover.Panel>
                                        </Transition>
                                    </Popover>
                                </Popover.Group>
                            </div>
                        </div>
                        {/*<Menu as="div" className="relative inline-block text-left">
                            <div>
                                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                    Trier les chemins
                                    <ChevronDownIcon
                                        className="-mr-1 ml-1 h-5 w-5 shrink-0 text-gray-400 group-hover:text-gray-500"
                                        aria-hidden="true"
                                    />
                                </Menu.Button>
                            </div>

                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items className="absolute right-0 z-30 mt-2 w-52 origin-top-left rounded-md bg-white shadow-2xl ring-1 ring-orange-300 ring-opacity-5 focus:outline-none">
                                    <div className="py-1">
                                        {sortOptions.map((option) => (
                                            <Menu.Item key={option.id}>
                                                {({ active }) => (
                                                    <span
                                                        onClick={() => {}}
                                                        className={cx(
                                                            "block px-4 py-2 text-sm"
                                                            // {
                                                            //     "font-medium text-orange-600":
                                                            //         option.id == orderBy,
                                                            //     "text-gray-500":
                                                            //         option.id != orderBy,
                                                            //     "bg-gray-100": active,
                                                            // }
                                                        )}
                                                    >
                                                        {option.name}
                                                    </span>
                                                )}
                                            </Menu.Item>
                                        ))}
                                    </div>
                                </Menu.Items>
                            </Transition>
                        </Menu>*/}
                    </div>
                </div>
            </section>
        </div>
    );
}
